import { render, staticRenderFns } from "./svg-caret-down.vue?vue&type=template&id=831b6166"
import script from "./svg-caret-down.vue?vue&type=script&lang=js"
export * from "./svg-caret-down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.bun/vue-loader@15.11.1+1fd801dffddf8165/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports